export const SET_SCOPE_ACTIVITY = 'SET_SCOPE_ACTIVITY'
export const SET_EMPLOYMENT = 'SET_EMPLOYMENT'
export const SET_EXPERIENCE = 'SET_EXPERIENCE'
export const SET_COMPANY = 'SET_COMPANY'
export const SET_CITY = 'SET_CITY'



// WEBPACK FOOTER //
// ./src/constants/Filter.js